import { Component, Input } from '@angular/core';
import { ICommitteeRole, INominatingOrganisation } from './../shared/models/nom-org';
import { ITableColumn, TableColumnType } from '../../controls/table/table-column';

@Component({
    selector: 'app-nom-org-committee',
    templateUrl: './nom-org-committee.component.html',
    styleUrl: './nom-org-committee.component.scss',
    standalone: false
})
export class NomOrgCommitteeComponent {

  @Input() loading: boolean = false;
  @Input() committees: ICommitteeRole[] = [];


  tabIds = {
    committeesRepresentedOn: 'committeesRepresentedOn',
    projects: 'projects',
    myRepresentatives: 'myRepresentatives',
    subCommitteesAndWorkingGroups: 'subCommitteesAndWorkingGroups',
    declarationOfInterest: 'declarationOfInterest',
  };

  committeeTableData: ICommitteeRole[] = [];
  committeeTableColumns: ITableColumn<ICommitteeRole>[] = [
    {
      name: 'committeeCode',
      displayName: 'Committee',
      type: TableColumnType.routerLink,
      isSortable: true,
      getLink: (row: ICommitteeRole) => `/committees/${row.committeeCode}`,
      headerWidth: '220px'
    },
    {
      name: 'sectorName',
      displayName: 'Sector',
      isSortable: true
    }
  ];



  constructor() {}


  ngOnInit(): void {

  }

  ngAfterViewInit() {

  }


  onTabChange(tabId: string) {

  }

}
